export const Toolbar = {
  MuiDialog: {
    root: {
      "& .CirrusToolbar": {

        "& .CirrusSelector": {
        },

      },
    },
  }
}
